define('models/ProductModel',['underscore', 'ObjectModel', 'LocalStorage', 'site_vars', 'UrlFactory', 'app', 'router', 'hooks',
        'models/SidedishCollection', 'models/IngredientCollection',
        'sprintf',
        'models/TagCollection',
        'models/StoreModel',
        'models/ProductBoostModel',
        'formatPrice',
		'models/AllergenGroupCollection'

	],
    function (_, ObjectModel, LocalStorage, site_vars, UrlFactory, app, router, hooks,
            SidedishCollection, IngredientCollection,
            sprintf,
            TagCollection,
            StoreModel,
            ProductBoostModel,
            formatPrice,
            AllergenGroupCollection)
    {
        //
        // Model Product
        //
        var SUFFIX_BLOCK_INGREDIENT = 'block_ingredient_';

        function defaultCart(cart){
            return cart ? cart : app.getCart();
        }

        var TRANSLTATION_PRODUCT_CONTEXT = 'Product',
            TRANSLATION_STOCKOUT_LABEL = 'Victime de son succès';

        var IMG_200x200 = '200x200',
            IMG_120x120 = '120x120',
            IMG_60x60 = '60x60';

        var ProductModelPrototype = {

            name: 'ProductModel',
            idAttribute: 'id_product',
            route: 'apiProductModel',
            isModelFetched:false,


            hasPaymentRestriction:function() {

                return this.get('has_payment_restrictions')
            },
            getPaymentRestriction:function() {

                return this.get('payment_restrictions')
            },
            initialize: function ()
            {
                // ObjectModel constructor heritage
                var model = this;
                ObjectModel.prototype.initialize.apply(model, arguments);
                //
                if (!model.get(model.idAttribute)) {
                    model.attributes[model.idAttribute] = model.get('id');
                }
                if(model.get('is_menu')){
                    model.listenTo(app.getCart(),'change:id_store',model.cleanSidedishes);
                }
                model.on('sync',model.onSync);
            },
            onSync:function(){
                this.isModelFetched = true;
            },
            isSync:function(){
                return this.isModelFetched === true;
            },
            getAdditifs:function () {
                return this.get('additifs') || ''
            },
            isFixedRecipe:function(){
                return !!this.get('fixed_recipe');
            },
            getExtraClass:function(){
                var classProduct = this.get('class');
                if (classProduct) {
                    return  classProduct.join(',');
                }else
                {
                    return "";
                }
            },
            useBlockType:function(){
                var blockType = this.get('block_type');
                return blockType > 0;
            },
            getBlockType:function(ignoreBlockType){
                var blockType = this.get('block_type'), blockTypeName;
                switch(ignoreBlockType ? 0 : blockType){
                    case 0:
                    default:
                        blockTypeName = 'default';
                        break;
                    case 1 :
                        blockTypeName = 'double';
                        break;
                    case 2 :
                        blockTypeName = 'zoom2x';
                        break;
                }
                return blockTypeName;
            },
            getBlockClass:function(ignoreBlockType){
               var product = this,
                   cart = app.getCart(),
                   classes = [
                       'block-type--'+this.getBlockType(ignoreBlockType),
                        product.isBuyableInContext(cart) ? 'buyable':'not-buyable',
                        product.allowPreorder()	 ? 'allow-preorder':'',
                        product.isStockout() ? 'is-stockout':'' ,
                        product.getAvisverifie() ? 'has-avisverifie' : ''
                   ];
               return classes.join(' ');
            },
            getAccompagnement:function () {
                return '';
            },
            getType:function () {
                return '';
            },
            getName: function ()
            {
                return this.get('name')
            },
            getTitle: function ()
            {
                return this.get('titre_seo') || this.getName();
            },
            getPieces: function ()
            {
                return parseInt(this.get('quantity'))
            },
            displayPieces: function(){
                var q = this.getQuantity();
                return q>0 ? app.t("%s pièce"+(q>1?"s":""), TRANSLTATION_PRODUCT_CONTEXT, this.getQuantity()):"";
            },
            getTemplate:function () {
                var model = this,
                    templateSProduct = model.get('template');

                if (templateSProduct)
                {

                    return templates[templateSProduct];
                }else
                {
                   return false;
                }

                //  return templates.ComponentsVodTemplatesSidedishBlock;
            },
            getDescription:function (){
                return this.get('description');
            },
            getDescriptionHtml:function (){
                return this.get('description_html') || this.getDescription();
            },
            getSmallDescription: function ()
            {
                return this.get('description_short')
            },
            canBeOffered:function(){

                return app.getCart().productCanBeOffered() && this.isLiked();
            },
            getMacaron: function ()
            {
                var id_macaron = this.get('id_macaron');
                if (id_macaron) {
                    return app.getMacaron(id_macaron);
                }
            },
            formatMacaron:function(){
                var macaron = this.getMacaron();
                if(macaron){
                    return macaron.getName();
                }else{
                    return '';
                }
            },
            isActiveVae:function()
            {
                return this.get('enable_vae');
            },
            isActiveVad:function()
            {
                return this.get('enable_vad');
            },
            getCategories: function ()
            {
                return app.getCategories().filterByProduct(this.id)
            },

            getCategoryDefault: function ()
            {
                var model = this;
                if (model.get('id_category_default')) {
                    var default_category = app.getCategory(model.get('id_category_default'));
                }
                // si la catégorie par défaut n'est pas disponible, on cherche à utiliser une autre catégorie
                if (!default_category) {
                    default_category = model.getCategories()[0]
                }
                return default_category;
            },
            getLinkRewrite: function ()
            {
                return this.get('link_rewrite')
            },
            getUrl: function ()
            {
                var model = this,
                    url = model.get('url'); // cached url
                if(!url){
                    url = model.get('deleted') ? '#' : UrlFactory.getUrl('product',model.getUrlOptions());
                    model.set('url',url);
                }
                return url;
            },
            getUrlOptions:function(){
                var product = this,
                    category = product.getCategoryDefault(),
                categoryRewrite = category ? category.getLinkRewrite() : 'product';
                return {
                    category_link_rewrite: categoryRewrite,
                    product_link_rewrite: product.getLinkRewrite(),
                    id_product: product.id
                };
            },
            getPicture: function ()
            {
                return this.getPictures()[0];
            },
            getPictures:function(type){
                type = type || 'productCover';
                return _(this.get('pictures')).filter(function(p){
                    return _(p.types).contains(type);
                });
            },
            getPictureByType:function(type){
                var typedPictures = this.getPictures(type);
                return typedPictures[0] || false;
            },
            getCustomProductPictureUrl:function(type){
                var productCustomPicture = this.getPictureByType('productCustom');
                return this.getPictureUrl(type || 'single',productCustomPicture);
            },
            getPicturesExtended:function(origin){
                var model = this;
                return _(_(model.getPictures().map(function(picture){
                    var legend = picture.legend,
                        url = model.getPictureUrl(origin,picture);
                    return {
                        img: '<img src="'+url+'" alt="'+legend+'" />',
                        legend:legend,
                        url:url
                    };
                })));
            },
            getPictureUrl: function (origin, picture)
            {
                if (_.isUndefined(picture)) {
                    picture = this.getPicture()
                }
                var format, url;
                if(origin === 'thumb' || origin === 'line'){
                    format = Modernizr.retina ? IMG_120x120:IMG_60x60;
                }else if(origin === 'listing'){
                    if(app.isDesktop()){
                        switch(this.getBlockType()){
                            default:
                                format = IMG_200x200;
                                break;
                            case 'zoom2x':
                                format = '280x280';
                                break;
                            case 'double':
                                format = '300x150';
                                break;
                        }
                    }else{
                        format = Modernizr.retina ? IMG_120x120:IMG_60x60;
                    }
                }else if(origin === 'single'){
                    format = '400x400';
                }else if(origin === 'large'){
                    format = '1080x1080';
                }else if(origin === 'consumable'){
                    format = app.isDesktop() ? '80x80' : '100x100';
                }else{
                    // origin == block
                    format = IMG_200x200;
                }
                if (picture) {
                    url = app.getPictureUrl(picture.id_object_picture, 'Product', format, 'PNG', this.getLinkRewrite());
                } else {
                    url = site_vars.img_url + 'product-default.png'
                }

                return url;
            },
            getAllIngredient: function ()
            {
                var model = this,
                    ingredientCollection = new IngredientCollection();
                _([1,2]).each(function(n){
                    _(model.get(SUFFIX_BLOCK_INGREDIENT+n)).each(function(id_ingredient){
                        ingredientCollection.add(
                            app.getIngredient(id_ingredient)
                        )
                    });
                });
                return ingredientCollection;
            },
            getAllIngredientsCount:function(){
                var model = this;
                return _([1,2]).reduce(function(sum,n){
                    var ingredients = model.get(SUFFIX_BLOCK_INGREDIENT+n) || [];
                    return sum + (ingredients.length || 0);
                },0);
            },
            getAllIngredientsName:function(){
              return this.getAllIngredient().map(function(i){return i.get('name')}).join(', ');
            },
            getBlockIngredient: function (n)
            {
                var ingredientCollection = new IngredientCollection();
                _(this.get(SUFFIX_BLOCK_INGREDIENT + n)).each(function (id_ingredient)
                {
                    ingredientCollection.add(
                        app.getIngredient(id_ingredient)
                    )
                });
                return ingredientCollection;
            },
            getAllergenGroups: function ()
            {
                var model = this,
                    allergenGroups = model.allergenGroups;
                if(!allergenGroups){
                    allergenGroups = model.allergenGroups = app.getAllergenGroups().whereIds(this.get('allergengroup'));
                }
                return allergenGroups;
            },
            getTags: function ()
            {
                var model = this,
                    tags = model.tags;
                if(!tags){
                    tags = model.tags = app.getTags().whereIds(this.get('tag'));
                }
                return tags;
            },
            getAvisverifie: function() {
                var _AVIS_VERIFIE_MIN_REVIEW_ = parseInt(app.c('_AVIS_VERIFIE_MIN_REVIEW_')),
                _AVIS_VERIFIE_MIN_AVG_ = parseFloat(app.c('_AVIS_VERIFIE_MIN_AVG_')),
                count_avis_verifie = parseInt(this.get('count_avis_verifie')),
                avg_avis_verifie = parseFloat(this.get('avg_avis_verifie')).toFixed(1),
                avis_verifie_enabled = app.c('_IS_AVIS_VERIFIE_ACTIVE_') === '1'

                return (
                    avis_verifie_enabled &&
                    count_avis_verifie > _AVIS_VERIFIE_MIN_REVIEW_ &&
                    avg_avis_verifie > _AVIS_VERIFIE_MIN_AVG_
                )
                    ? avg_avis_verifie
                    : false
            },
            getQuantity: function ()
            {
                return this.get('quantity');
            },
            getCartQuantity: function(){
                var model = this, qty = 0, cart = app.getCart();
                if(model.isMenu(true)){
                    cart.getProducts().each(function(cartProduct){
                        qty += cartProduct.get('id_product') === model.id ? 1 :0;
                    });
                }else{
                    var cartProduct = cart.getProduct(model.id);
                    qty = cartProduct ? cartProduct.getQuantity() : 0;
                }
                return qty;

            },
            // distingue les CartProduct des Product
            editableQuantity:function(){return false},
            deletable:function(){return false},
            isCartProduct:function(){return false},
            //
            getKiloJoules: function ()
            {
                return parseFloat(this.get('kilojoules'));
            },
            displayEnergy:function(){
                var kJ = this.getKiloJoules(),
                    _ENERGY_DECIMALS_SIGN_ = app.c('_ENERGY_DECIMALS_SIGN_',','),
                    _ENERGY_UNIT_ = app.c('_ENERGY_UNIT_','%s kJ.'),
                    kJtoUnit = (kJ / parseFloat(app.c('_ENERGY_CONVERSION_RATE_',1))).toFixed(parseInt(app.c('_ENERGY_DECIMALS_',0))),
                    Energy = kJtoUnit.toString().replace(/[,\.]/,_ENERGY_DECIMALS_SIGN_);
                if(app.c('_ENERGY_ROUND_ZERO_','1')==1){
                    // remove final Zero
                    Energy = Energy.replace(new RegExp(_ENERGY_DECIMALS_SIGN_+'0+$'),'');
                }
                return sprintf.sprintf(_ENERGY_UNIT_,Energy);

            },
            getHtmlImg: function (origin)
            {
                return '<img src="' + this.getPictureUrl(origin) + '" title="' + this.getName() + '" />';
            },
            getPrice: function (type, inContext, cart)
            {

                var product = this,
                    store,
                    inContext = inContext == true,
                    price;

                if(inContext){
                    cart = defaultCart(cart);
                    store = cart.getStore();
                }

                if (_.isUndefined(type) || !type) {
                    type = 'ttc';
                }
                if (inContext && (cart.isVAE() && cart.hasStore()) && type == 'ttc') {

                    type += '_vae';
                }

                if (inContext && store && store.hasModifiers()) {
                    price = store.getProductPrice(product, type);
                }
                else {
                    price = parseFloat(product.get('price_' + type));
                }


                return price;
            },
            getUnavailableMessage:function(){
                var defaultMessage = app.t("Produit non disponible","Account");
                return this.isStockoutNow() ? app.t(TRANSLATION_STOCKOUT_LABEL,TRANSLTATION_PRODUCT_CONTEXT) :
                        this.get('indisponibility_message') || defaultMessage;
            }
            ,
            getExtraDisplayPrice:function() {
                var extraDisplayPrice = this.get('extradisplayprice') || [], r = [];
                // Todo
                // attention c'est assez dangereux comme modele de données,
                // car on se fie sur la clé / valeur avec le postulat qu'elle est unique
                _(extraDisplayPrice).each(function(object,index){
                    var key = _.keys(object)[0],
                        value = parseFloat(_.values(object)[0]);
                    //
                    r.push({
                        name:key,
                        price_ttc:value
                    });
                });
                return _(r);
            },
            formatPriceValue: function (value, formatOptions)
            {
                return formatPrice(value, formatOptions);
            },
            formatPrice: function (type, inContext, cart, formatOptions)
            {
                return formatPrice(this.getPrice(type, inContext, cart), formatOptions);
            },
            formatPriceQty: function (type, qty, formatOptions, inContext, cart)
            {
                return formatPrice((this.getPrice(type, inContext, cart) * qty), formatOptions);
            },

            formatSidedishPrice:function(wrapperString,sidedish){
                var product = this,
                    price_label = '',
                    product_price = product.getPrice();
                if(product.isStockout()){
                    price_label = app.t(TRANSLATION_STOCKOUT_LABEL,TRANSLTATION_PRODUCT_CONTEXT);
                }else if((sidedish && sidedish.isFree()) || (product_price===0)){
                    if(sidedish && sidedish.isFreeDisplay()){
                        price_label = app.t("offert",TRANSLTATION_PRODUCT_CONTEXT);
                    }
                }else{
                    price_label = formatPrice(product.getPrice('ttc', true),{
                        auto_round_decimal:true
                    });
                    if(sidedish && sidedish.isPlusDisplay()){
                        price_label = '+'+price_label;
                    }
                }
                return price_label!==''?sprintf.sprintf(wrapperString,price_label):'';
            },

            isMenu: function (ignoreSidedish)
            {
                // cette fonction est contextuelle,
                // elle dépend des produits avec accompagnement midi/soir variable
                return this.get('is_menu') && (ignoreSidedish || !!this.getSidedishes().size());
            },
            hasSteps: function(){
                var product = this;
                return ((product.isMenu() && !product.isCustomBox42()) || product.isCustomBox42Menu());
            },
            countSteps: function(){
                var product = this, count = 0, sidedishes;
                if(product.isMenu()){
                    sidedishes = product.getSidedishes();
                    count = sidedishes.sizeRoot();
                    count += product.isCustomBox42() ? 0 : 1;
                }
                return count;
            },
            isCustomBox42: function() {
                var model = this,
                    isCustomBox42 = model.isMenu();
                if(isCustomBox42) {
                    var firstSidedish = model.getSidedishes().at(0);
                    isCustomBox42 = !!firstSidedish && (firstSidedish.get('template') === 'custom_box_42')
                }
                return isCustomBox42;
            },
            isCustomBox42Menu: function() {
                // permet de savoir si le produit Box à composer
                // a aussi des cross-selling en plus
                var model = this, result = false
                if (model.isCustomBox42()) {
                    model.getSidedishes().each(function(sidedish) {
                        if (sidedish.get('template') !== 'custom_box_42') {
                            result = true
                        }
                    })
                } else {
                    result = false
                }
                return result
            },
            isLiked: function ()
            {
                var customer = app.getCustomer();
                return customer.isLogged() && customer.isProductLiked(this.id);
            },
            isInCategory: function(category){
                return _(this.getCategories()).contains(category);
            },
            isInCategorySlug: function(categorySlug){
                return this.isInCategory(app.getCategoryBySlug(categorySlug));
            }
            ,
            getSidedishes: function (){
                var sidedishCollection = this.sidedishes;
                if(!sidedishCollection){
                    sidedishCollection = this.resetSidedishes();
                }
                return sidedishCollection;
            },
            resetSidedishes: function(accompagnements){
                var product = this,
                    sidedishes = product.get('sidedishes'),
                    initialSerializedSelection = false;
                if(!accompagnements && !!(initialSerializedSelection = product.get('initialSerializedSelection'))){
                    initialSerializedSelection = JSON.parse(initialSerializedSelection);
                    product.unset('initialSerializedSelection');
                }
                return this.sidedishes = SidedishCollection.prepareSelection(sidedishes,app,accompagnements,initialSerializedSelection);
            },
            cleanSidedishes:function(){
                this.sidedishes = false;
            },
            getProductBoost:function(){
                var model = this,
                    product_boost = model.get('product_boost') || false,
                    productBoost = product_boost ? model.productBoost : product_boost;
                if(product_boost && !productBoost){
                    product_boost.id_product_source = model.id;
                    productBoost = new ProductBoostModel(product_boost);
                    // le boost est unique, par produit, pendant la durée de la navigation
                    model.productBoost = productBoost;
                }
                return productBoost;
            },
            requireProductBoost:function(){
                var productBoost = this.getProductBoost();
                return !!productBoost && productBoost.requireProductBoost();
            },
            getProductStore:function(){
                var product = this,
                    cart = app.getCart(),
                    store = cart.getStore(),
                    cartValidate = cart.validateDeliveryOptions(),
                    productStore;

                if (store && store.hasModifiers() && cartValidate) {
                    // product
                    productStore = store.getProduct(product);
                    // si on a une boutique et qu'on a pas le produit,
                    // il est implicitement concidéré comme désactivé du contexte
                }
                return !productStore ? false : productStore;
            },
            isStockout:function(ignoreRecursive){
                // par défaut, si le produit n'est pas dans le catalogue
                // ou qu'il n'y a pas de boutique valide, le produit n'est pas en rupture de stock
                var model = this,
                    productStore = model.getProductStore(),
                    isStockout = productStore ? !!productStore.isStockout : false;
                if(!isStockout && model.isMenu() && !ignoreRecursive){
                    model.getSidedishes().each(function(sidedish){
                        if(!isStockout && sidedish.getCategory()) {
                            // si le sidedish est obligatoire et que tous les produits sont indisponibles
                            var is_required = sidedish.isRequired(),
                                products,
                                products_size,
                                stockout_count = 0;
                            if(is_required){ // on vérifie que le cross-selling est obligatoire
                                products = sidedish.getCategoryProducts();
                                products_size = products.size();
                                if(products_size>0){ // et qu'il a *dans le contexte* des produits
                                    // si il n'y en a pas, ça peut être lié à une distinction VAE/VAD
                                    products.each(function(p){
                                        stockout_count += (!p.isBuyableInContext(app.getCart(),true) && p.isStockout(true)) ? 1 : 0;
                                    })
                                    isStockout = products.size() === stockout_count;
                                }
                            }
                            // ou si un produit immuable est en rupture de stockout
                            // if(!isStockout){
                            //     id_product_immutable = sidedish.get('id_product_immutable');
                            //     _(id_product_immutable).each(function(id_product){
                            //         var p = app.getProduct(id_product);
                            //         isStockout = isStockout || (!!p && !p.isBuyableInContext() && p.isStockout());
                            //     })
                            // }
                        }
                    })
                }
                return isStockout;
            },
            isStockoutNow:function(){
                // rupture de stock à chaud
                var product = this,
                    cartProduct = app.getCart().getProduct(product.id),
                    isStockout = product.isStockout();
                return isStockout || (!!cartProduct && cartProduct.get('available_msg') === 'STOCKOUT');
            },
            allowPreorder:function(){
                return this.get('preorder_type') > 0;
            },
            getPreorderButtonLabel:function(){
                var cart = defaultCart(),
                    type = this.isBuyableInContextType(cart),
                    label,
                    translationContext = TRANSLTATION_PRODUCT_CONTEXT;
                switch(type){
                    case 5: // switch VAD to VAE
                        label = cart.isVAE() ?'En livraison':'À emporter';
                        translationContext = 'Cart';
                        break;
                    default:
                        label = 'Précommander';
                }
                return app.t(label,translationContext);
            },
            hasNutritionalData:function () {
                var n = this.get('nutritional_data');

                if(!n || (!n.line.length ||  !n.col.length)) return false;
                return true;
            },
            getNutritionalData:function(){
                var n = this.get('nutritional_data');

                if(!n) n = {col:[],line:[]};
                return n;
            },
            getNutritionalDataCol: function(){
                return _(this.getNutritionalData().col);
            },
            getNutritionalDataLine: function(){
                return _(_(this.getNutritionalData().line).map(function(line){
                    return {
                        name:line.name,
                        col:_(line.col)
                    }
                }));
            }, isAvailable: function () {return true},
            isBuyableInContext:function(cart,ignoreRecursive){
                return this.isBuyableInContextType(cart,ignoreRecursive) === 0;
            },
            isBuyableInContextType:function(cart,ignoreRecursive){


                var product = this,
                    cart = defaultCart(cart),
                    visibility = product.get('visibility');

                if(product.get('deleted')) return 1;

                //
                // actif sur le web
                //
                if(!product.isActive()){
                    return 1;
                }
                //
                // disponibilité par boutique
                //
                if (!product.isActiveInStore(cart)) {
                    return 2;
                }

                //
                // disponibilité par période [from,to]
                //
                if(!product.isActiveFromTo(cart)){
                    return 3;
                }

                //
                // disponibilité par créneau horaire et jour
                // valeurs dispobibles :
                //      never | always | {from,to,active} | [{from,to,active},...]
                //
                if(!isCartMomentVisible(visibility,true,cart)){
                    return 4;
                }

                // si le mode de livraison n'est pas permis
                if(!product.allowDeliveryMode(cart)){
                    return 5;
                }

                // si le produit est en rupture de stock
                if(product.isStockout(ignoreRecursive)){
                    return 6;
                }

                return 0;

            },
            isActiveFromTo:function(cart, onlyVisible){
                //
                // disponibilité par période [from,to]
                //
                var product = this,
                    // cart = app.getCart(),
                    cart = defaultCart(cart),
                    cartMoment = cart.getDatetimeMoment(),
                    from = product.get('from'),
                    to = product.get('to');

                from = from ? from.replace(/-/g,'/') : false;
                to = to ? to.replace(/-/g,'/') : false;
                if((onlyVisible === true) && (product.get('display_outdated'))){ // vérifie seulement la visibilité
                    return true;
                }
                if (from) {
                    if (!(cartMoment.isAfter(new Date(from)))) {
                        return false;
                    }
                }
                if (to) {
                    if (!(cartMoment.isBefore(new Date(to)))) {
                        return false;
                    }
                }
                return true;
            },
            isActiveInStore:function(cart){
                //
                // disponibilité par boutique
                //
                cart = defaultCart(cart);

                var product = this,
                   store = cart.getStore(),
                   cartValidate = cart.validateDeliveryOptions(),
                   productStore,
                   isValid = true;
                if (store && store.hasModifiers() && cartValidate) {
                    // product
                    productStore = store.getProduct(product);
                    // si on a une boutique et qu'on a pas le produit,
                    // il est implicitement concidéré comme désactivé du contexte
                    if (!productStore) {
                        isValid = false;
                    }
                }

                hooks.execHook('productCanBeSee',{product:this, store:store},function(val){
                    isValid = false;
                });
                return isValid;
            },
            getCustomerGroup:function () {
                return this.get('customer_group');
            },
            isActive:function(){
                return !!this.get('active_web');
            },
            isVisibleInContext: function (withFilters, cart)
            {
                cart = defaultCart(cart);
                //
                // l'attribut withFilters, permet d'utiliser le filtre par tags et allergenGroups
                //

                var product = this,
                    visibility = product.get('visibility'),
                    // si le produit est disponible en prévente, on considère que ça permet de l'afficher
                    allowPreorderMode = product.allowPreorderMode(cart);



                //
                // actif sur le web
                //
                if(!product.isActive()){
                    return false;
                }
                //
                // disponibilité par boutique
                //

                if (_(product.getCustomerGroup()).intersection(app.getCustomer().getCustomerGroup()).length == 0)
                {
                    return false;

                }
                if (!product.isActiveInStore(cart)) {
                    return false;
                }

                // disponibilité par période [from,to]
                //
                if(!product.isActiveFromTo(cart,true)){
                    return false;
                }

                if(!product.allowDeliveryMode(cart) && !allowPreorderMode){
                    return false;
                }
                //
                // disponibilité par créneau horaire et jour
                // valeurs dispobibles :
                //      never | always | {from,to,active} | [{from,to,active},...]
                //
                if(!isCartMomentVisible(visibility,false,cart) && !allowPreorderMode){
                    return false;
                }

                if(withFilters){
                    return product.isFiltred(cart);
                }
                return true;
            },

            allowPreorderMode:function(cart){
                cart = defaultCart(cart);
                var product = this,
                    preorder_type = product.get('preorder_type'),
                    allowPreorder = preorder_type > 0,
                    allow = allowPreorder;
                //    0 => 'ne pas précommander',
                //    1 => 'précommander',
                //    2 => 'précommander en VAE',
                //    3 => 'précommander en VAD',
                if(allowPreorder) {
                    if (!product.allowDeliveryMode(cart)) {
                        // si le produit est précommandable MAIS
                        // n'est pas actif dans le mode de livraison,
                        // on vérifie qu'on doit permettre la bascule VAE/VAD
                        if (cart.isVAD() && (preorder_type !== 2)) {
                            allow = false;
                        }
                        if (cart.isVAE() && (preorder_type !== 3)) {
                            allow = false;
                        }
                    }
                }
                return allow;
            },
            allowDeliveryMode:function(cart){
                if (cart.isVAD() && !this.isActiveVad()) {
                    return false;
                }
                if (!cart.isVAD() && !this.isActiveVae()) {
                    return false;
                }
                return true;
            },
            isFiltred:function(cart){
                // renvoie true, si le produit est visible dans la selection de filtre (tag et allergen)

                var product = this,
                    productTags = product.getTags(),
                    productAllergenGroups = product.getAllergenGroups(),
                    validateStockout = true,
                    validateTag = productTags.size() === 0 || !app.getTags().isFilterChecked(),
                    validateAllergenGroup = productAllergenGroups.size() === 0 || !app.getAllergenGroups().isFilterChecked();

                // si des filtres tags ont été selectionnés
                if(!validateTag) {
                    // et si le produit a des tags et q'un des tags est selectionné
                    validateTag = false;
                    productTags.each(function (tag) {
                        validateTag = validateTag || tag.isChecked();
                    });
                }
                // si des filtres d'allergene ont été déselectionnés
                if(!validateAllergenGroup) {
                    validateAllergenGroup = true;
                    // et si le produit a des allergen et qu'aucun n'est selectionné
                    productAllergenGroups.each(function (allergenGroup) {
                        validateAllergenGroup = validateAllergenGroup && allergenGroup.isChecked();
                    });
                }

                return validateTag && validateAllergenGroup && validateStockout;
            },
            hasContextualData:function(){
                // est-ce que le produit a des données contextuelles (priceByShop, etc.)
                var hasContextualData = false;
                hooks.execHook('productHasContextualData',this,function(){
                    hasContextualData = true;
                });
                return hasContextualData;
            }

        };

        function isCartMomentVisible(fromTo,buyable,cart){
            var cart = defaultCart(cart),
                cartValidate = cart.validateDeliveryOptions(),
                cartMoment = cart.getDatetimeMoment(),
                cartMomentDay = cartMoment.format('YYYY/MM/DD '),
                isVisible;
            // se base sur les modifier du store, et sur le contexte horaire panier
            if(fromTo == 'always') {
                // si on pas de panier validé (donc pas d'horaire)
                // ou
                // si le produit est toujours actif
                isVisible = true;
            }else if(_.isArray(fromTo)){
                // on utilise l’index du jour du contexte 1 = lundi | 0 = dimanche (c'est faux!)
                // TODO attention l’API est lundi = 0
                isVisible = isCartMomentVisible(fromTo[(cartMoment.day()+7-1)%7],buyable,cart);
            }else if(fromTo.from && fromTo.to){
                // si le produit est dans le créneau horaire panier
                //    isVisible = true;
                isVisible = cartMoment.isAfter(new Date(cartMomentDay+fromTo.from)) && cartMoment.isBefore(new Date(cartMomentDay+fromTo.to));
                if(!buyable){
                    // l'option buyable permet d'afficher même des produits non achetable
                    isVisible = isVisible || fromTo.display_message;
                }
            }else{
                // par défault, ce cas ne devrait pas arriver
                isVisible = false;
            }
            return isVisible;
        }

        var ProductModel = ObjectModel.extend(LocalStorage).extend(ProductModelPrototype);

        return ProductModel;
    });
